export * from './window-provider';